import { useEffect, useState } from 'react'
import { useGoogleLocationClient } from '../api/GoogleLocationClientContext'
import {
  createPlaceSearch,
  initialPlaceSearchState,
  PlaceSearchState
} from '../search/placeSearch'

/**
 * `createPlaceSearch` for one mounted search box. Leaving the view resets it,
 * which aborts what is in flight and drops the session token.
 */
export function usePlaceSearch() {
  const client = useGoogleLocationClient()
  const [state, setState] = useState<PlaceSearchState>(initialPlaceSearchState)
  const [search] = useState(() =>
    createPlaceSearch({
      autocomplete: client.autocomplete,
      onChange: setState
    })
  )

  useEffect(() => () => search.reset(), [search])

  return { state, search }
}
